/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {isEmpty} from '../../../helpers/generic-helpers';

@Component({
    selector: 'app-vehicle-scenario-select-pop-up',
    templateUrl: './vehicle-scenario-select-pop-up.component.html',
    styleUrls: ['./vehicle-scenario-select-pop-up.component.scss'],
    standalone: false
})
export class VehicleScenarioSelectPopUpComponent {
  protected readonly isEmpty = isEmpty;
  @Input() titleText: string;
  @Input() validFcorgs: string[] = [];
  @Input() isMultiSelect: boolean = false;
  @Output() confirmEvent = new EventEmitter<any>();

  selectedScenarios: any[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) protected readonly data: any,
              public dialogRef: MatDialogRef<VehicleScenarioSelectPopUpComponent>) {
    if (!isEmpty(data)) {
      this.titleText = data.title;
      this.validFcorgs = data.validFcorgs;
      this.isMultiSelect = (data.isMultiSelect !== undefined && data.isMultiSelect !== null) ? data.isMultiSelect : false;
    }
  }

  /**
   * Close popup window.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * sends data when pop up is closed
   */
  onSubmit(): void {
    this.dialogRef.close({
      selectedScenarios: this.selectedScenarios,
    });
  }

  /**
   * sets the current selected scenario as the scenario in the event
   * @param event The event emitted by the child component
   */
  onSelectEvent(event: any) {
    this.selectedScenarios = event.selectedScenarios;
  }
}
